

export const Address = ( {annotation, address1, address2, city, county, state, country, postalCode, className = ''} ) =>
    <address className={className}>
        {annotation &&
        <span className="block text-sm">{annotation}</span>
        }
        <span className="block">{address1} {address2}</span>
        <span className="block">{city}, {state} {postalCode} {country}</span>
        {county && <span className="block">{`${county} COUNTY`}</span>}
    </address>;
